import React, { useState } from 'react';
import NavDropdown from '../NavDropdown/NavDropdown';
import Dropdown from '../Dropdown';
import './NavMain.scss';

type Props = {
  menuSection: {
    items: Array<{
      icon?: React.ReactNode;
      title: string;
      to: string;
      onClick?: () => void;
    }>;
  };
  secondarySections?: Array<{
    items: Array<{
      icon: React.ReactNode;
      title: string;
      to: string;
    }>;
    mods: string;
  }>;
};

const NavMain: React.FC<Props> = (props) => {
  const { menuSection, secondarySections } = props;
  const [isOpenMenu, setIsOpenMenu] = useState(false);
  const bodyElement = document.body;

  // обработчик переключения меню
  function handleToggleMenu(isOpen: boolean): void {
    setIsOpenMenu(isOpen);
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    isOpen
      ? bodyElement.classList.add('main-navigation-opened')
      : bodyElement.classList.remove('main-navigation-opened');
  }

  return (
    <Dropdown
      className="dropdown_type_main-navigation"
      toggle={{
        icon: <span className="dropdown__handle-line" />,
        text: isOpenMenu ? 'Скрыть главное меню' : 'Показать главное меню',
      }}
      onToggle={handleToggleMenu}
    >
      <NavDropdown
        title="Главное меню"
        menuSection={menuSection}
        secondarySections={secondarySections}
        mods="navigation_hidden-title"
        mix="main-navigation"
      />
    </Dropdown>
  );
};

export default NavMain;
